




































































import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import CategoryList from '@/components/category/CategoryList.vue'
import CategoryModel from '@/_models/CategoryModel'
import UserType from '@/components/shared/UserType.vue'
import UserModel from '@/_models/UserModel'
import UserList from '@/components/user/UserList.vue'

// Common
import NotFound from '@/components/common/NotFound.vue'

@Component({
  components: {
    UserType,
    NotFound,
  },
  computed: {},
})
export default class CategoryUserList extends mixins(CategoryList, UserList) {
  @Prop()
  user!: UserModel

  categorySelected: any = new CategoryModel()
  userSelected: any = new UserModel()
  selectedMode: string = 'single'

  get userList(): UserModel[] {
    return this.filteredUsers.map((item) => (this.user._id === item._id ? this.user : item))
  }

  get filteredUsers(): UserModel[] {
    return this.users.filter((item: UserModel): boolean => {
      if (!this.categorySelected._id || !this.categorySelected.name) {
        return true
      }
      return item.category_name === this.categorySelected.name
    })
  }

  onCategorySelected(category: CategoryModel) {
    if (category._id) {
      this.categorySelected = category
    }
  }

  findCategoryById(categoryId: string) {
    const foundCategory = this.categories.find((item) => item._id === categoryId)
    if (foundCategory) {
      this.categorySelected = foundCategory
    }
  }

  onUserSelected(user: UserModel) {
    if (user._id) {
      this.userSelected = user
      this.$emit('userSelected', user)
    }
  }

  unEmitSelectedUser(userId: string) {
    const user = this.users.find((userInfo) => userInfo._id === userId)
    if (user) {
      if (user.category_id) {
        this.findCategoryById(user.category_id)
      }

      this.userSelected = user
    }

    return user
  }

  onBack() {
    if (this.categorySelected._id) {
      this.categorySelected = new CategoryModel()
      this.userSelected = new UserModel()
    }
  }

  @Watch('user')
  changeBeaconSelected() {
    if (this.user._id) {
      this.userSelected = this.user
    }
  }
}
